import React from 'react';
import { Page } from "@engenharia/react-tools";
import { CRow, CCol } from '@coreui/react';
import EmailConfigs from './EmailConfigs';

const Configs = () =>
  <Page title="Configurações" links={[
    { path: '/', label: 'Home' },
    { path: '/configs', label: 'Configurações' }]
  }>
    <CRow>
      <CCol md="7">
        <EmailConfigs />
      </CCol>
    </CRow>
  </Page>

export default Configs;